// extracted by mini-css-extract-plugin
module.exports = {"c1yol6":"c1yol6"};